import { render, staticRenderFns } from "./DynamicMenu.vue?vue&type=template&id=4ad8cbef&scoped=true"
import script from "./DynamicMenu.vue?vue&type=script&lang=js"
export * from "./DynamicMenu.vue?vue&type=script&lang=js"
import style0 from "./DynamicMenu.vue?vue&type=style&index=0&id=4ad8cbef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8cbef",
  null
  
)

export default component.exports